export default __webpack_public_path__ + "static/media/icon_arrow_up_white_16.cfd6ec6a.svg";